// eslint-disable-next-line import/no-cycle
import FiltersEditor from './filtersEditor';

export default FiltersEditor;
